import { FC, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';

import toast, { Toaster } from 'react-hot-toast';

import clsx from "clsx";

import { actionGetRoles } from "../../../redux/action/accessRights/actionRoles";
import { reducerRolesStatus } from "../../../redux/reducer/accessRights/reducers/roles";
import { AppDispatch } from "../../../redux/reducer/store";
import { generateStyles } from '../../../utils/generateToastStyles';

import RolesModal from "../../rolesModal/rolesModal";
import Loader from "../../custom/loader/loader";
import ToastPopup from '../../custom/toastPopup/toastPopup';

import "../table.scss";
import { IUserOptions } from "../../../types/interfaces";

interface IRoles {
  claimsCount: number;
  role: { id: number, name: string }
};

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableAdminRoles: FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const location = useLocation();

  const { roles, rolesCount, rolesStatus } = useSelector((state: any) => state.roles.roles);
  const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>("");
  const [roleClaims, setRoleClaims] = useState<number>(0);
  const [roleId, setRoleId] = useState<number>();
  const requestStatusOptions = [
    {
      status: 0,
      errorMessage: 'Роль администратора доступна только для чтения!',
    },
  ];

  const handleCloseModal = useCallback(() => {
    dispatch(actionGetRoles());
    setIsOpenModal(false);
    setRoleClaims(0);
    setModalTitle("");
  }, [dispatch]);

  useEffect(() => {
    dispatch(actionGetRoles());
  }, [dispatch]);

  useEffect(() => {
    const handleDocumentKeydown = (event: KeyboardEvent) => {
      if (event.keyCode === 27) {
        handleCloseModal();
      }
    };
    document.addEventListener("keydown", handleDocumentKeydown);
  }, [handleCloseModal]);

  const handleOpenModal = (name: string, id: number, claim: number) => {
    setIsOpenModal(true);
    setRoleClaims(claim);
    setModalTitle(name);
    setRoleId(id);
  };

  useEffect(() => {
    if (rolesStatus !== null) {
      requestStatusOptions.forEach((option: { status: number, successMessage?: string, errorMessage?: string }) => {
        if (rolesStatus === option.status) {
          toast.dismiss();
          toast(
            t => (
              <ToastPopup
                title={
                  option.successMessage
                    ? option.successMessage
                    : option.errorMessage
                }
                isSuccess={option.successMessage ? true : false}
                toast={toast}
                t={t}
              />
            ),
            generateStyles(option.successMessage ? true : false)
          );
        }
      });

      setTimeout(() => {
        dispatch(reducerRolesStatus(null));
      }, 5000);
    }
    // eslint-disable-next-line
  }, [dispatch, rolesStatus]);

  useEffect(() => {
    toast.dismiss();
  }, [location]);

  return (
    <>
      <div className="loader__wrapper">{!roles && <Loader />}</div>
      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
          isOpenSidebar &&
          "active__table",
          !isOpenSidebar && "closed__table",
          "table"
        )}
      >
        {(rolesStatus && rolesStatus !== null) && <Toaster
          position='top-center'
          toastOptions={{
            duration: 5000,
          }}
        />}
        <div className="table__wrapper">
          <table>
            <thead className="accessRights__thead">
              <tr>
                <th>Название</th>
                <th>Архив</th>
                <th>Кол-во клейм</th>
              </tr>
            </thead>
            <tbody>
              {roles &&
                roles.map((role: IRoles, index: number) => (
                  <tr
                    onClick={() =>
                      handleOpenModal(
                        role.role.name,
                        role.role.id,
                        role.claimsCount
                      )
                    }
                    className="active__link_tr"
                    key={index}
                  >
                    <td>{role.role?.name}</td>
                    <td>undefined</td>
                    <td>{role.claimsCount}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div className="pagination">
          <div className="pagination__count">Всего: {rolesCount}</div>
        </div>
      </div>
      {isOpenModal && (
        <RolesModal
          onClose={handleCloseModal}
          claims={roleClaims}
          title={modalTitle}
          id={roleId}
        />
      )}
    </>
  );
};

export default TableAdminRoles;